import api from './index'
import type { V1ApiResponse } from '@/types'

export const APP_LOGIN_SMS_CODE = 'appLoginSmsCode'

export interface SendSmsCodeParams {
  mobile: string
  smsPushCode?: string
}

export interface SendSmsCodeData {
  mobile: string
  smsPushCode: string
  countdown: number
  expiresIn: number
  blocked: boolean
}

export const smsApi = {
  sendVerificationCode: (
    params: SendSmsCodeParams
  ): Promise<V1ApiResponse<SendSmsCodeData>> =>
    api.post(
      '/v1/sms/verification-codes',
      {
        mobile: params.mobile,
        smsPushCode: params.smsPushCode || APP_LOGIN_SMS_CODE,
      },
      { noAuthRedirect: true, skipAuthRefresh: true } as any
    ),
}

export default smsApi
